import { useTranslation } from "react-i18next";
import { PersonalityMatrix } from "../../ParticipationFlow/components/personality-matrix";
import { PersonalityRole } from "../../../../types";
import { useTranslatedPersonalityRoles } from "../../ParticipationFlow/sub-pages/PersonalSummary/ReflectionPersonalSummary/useTranslatedPersonalityRoles";
import { ModuleProps } from "./../types";
import { useReflectionIndividualData } from "../hooks/useReflectionIndividualData";
import { BottomBar } from "../../ParticipationFlow/components/bottom-bar";

function ReflectionModule({ rawData, sessionId }: ModuleProps) {
  const { t } = useTranslation();
  const translatedKeys = useTranslatedPersonalityRoles();
  const reflectionIndividualData = useReflectionIndividualData({
    rawData,
    sessionId,
  });

  return (
    <>
      {reflectionIndividualData.topicsWithAnswers.leverages.map(
        (topic, index) => (
          <div className="page page-items" key={index}>
            <div className="content">
              <div className="content-header">
                <div className="title">
                  {t("individualPdfReport.leverages", "Leverages")}
                </div>
                <div className="subtitle">{topic.title}</div>
              </div>

              <div className="items-list">
                {topic.questions.map((question, i) => (
                  <div className="faq-item" key={i}>
                    <div className="faq-question">{question.title}</div>
                    <div className="faq-answer">{question.answer}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="footer">
              <BottomBar />
            </div>
          </div>
        )
      )}

      {reflectionIndividualData.topicsWithAnswers.challenges.map(
        (topic, index) => (
          <div className="page page-items" key={index}>
            <div className="content">
              <div className="content-header">
                <div className="title">
                  {t("individualPdfReport.challenges", "Challenges")}
                </div>
                <div className="subtitle">{topic.title}</div>
              </div>

              <div className="items-list">
                {topic.questions.map((question, i) => (
                  <div className="faq-item" key={i}>
                    <div className="faq-question">{question.title}</div>
                    <div className="faq-answer">{question.answer}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="footer">
              <BottomBar />
            </div>
          </div>
        )
      )}

      <div className="page page-items">
        <div className="content">
          <div className="content-header">
            <div className="title">
              {t("individualPdfReport.selfAssessment", "Self-assessment")}
            </div>
          </div>
          <PersonalityMatrix
            activeGridIndex={
              reflectionIndividualData.personalSummary.chartData
                .activeQuadrantIndex
            }
            gridLabels={[
              translatedKeys[PersonalityRole.Mediator].name,
              translatedKeys[PersonalityRole.Advisor].name,
              translatedKeys[PersonalityRole.Innovator].name,
              translatedKeys[PersonalityRole.Controller].name,
              translatedKeys[PersonalityRole.Director].name,
              translatedKeys[PersonalityRole.Motivator].name,
              translatedKeys[PersonalityRole.Brakeman].name,
              translatedKeys[PersonalityRole.Critic].name,
              translatedKeys[PersonalityRole.Driver].name,
            ]}
            mainLabels={{
              left: t("frontend.test.reflectionResults.community", "Community"),
              right: t("frontend.test.reflectionResults.success", "Success"),
              top: t(
                "frontend.test.reflectionResults.opportunities",
                "Opportunities"
              ),
              bottom: t("frontend.test.reflectionResults.security", "Security"),
            }}
            points={reflectionIndividualData.personalSummary.chartData.points}
          />
          <div className="role-wrapper">
            <div className="title">
              {t("frontend.test.reflectionResults.role", "Role")}:
            </div>
            <div className="personality-role">
              {
                translatedKeys[
                  reflectionIndividualData.personalSummary.chartData
                    .personalityRole
                ].name
              }
            </div>
            <div
              className="description"
              dangerouslySetInnerHTML={{
                __html:
                  translatedKeys[
                    reflectionIndividualData.personalSummary.chartData
                      .personalityRole
                  ].description,
              }}
            />
          </div>
        </div>

        <div className="footer">
          <BottomBar />
        </div>
      </div>
    </>
  );
}

export default ReflectionModule;
